import { User } from '../../types';
import { Permissions } from './AuthenticatedRoute';

export function checkPermission(user: User, permissions?: Permissions) {
  return permissions?.roles?.length
    ? permissions?.roles.includes(user?.userType)
    : true;
}
